<template>
  <v-container>
    <div v-if="!pckInfo">
      <h2 style="font-size:18px;">{{$t('Status')}}</h2>

      <table v-if="accError == ''" id="pckTable">
        <tr>
          <th style="background-color:#F4B95F;">{{$t('Package')}}</th>
          <td>{{packageName}}</td>
        </tr>
        <tr>
          <th style="background-color:#F4B95F;">{{$t('LimitItem')}}</th>
          <td>{{limitItemQty}}</td>
        </tr>
        <tr>
          <th style="background-color:#F4B95F;">{{$t('ExpireTime')}}</th>
          <td>{{expireTime}}</td>
        </tr>
      </table>
      <span v-if="accError != ''" style="padding-left:16px;" class="txtClrRed">{{accError}}</span>
      <br />

      <h2 style="font-size:18px;">{{$t('Package')}}</h2>

      <v-layout row wrap>
        <v-flex v-for="pck in packageList" :key="pck.name" xs6 sm4 md4 lg3>
          <a @click="clkPck(pck)">
            <v-card style="margin:10px;border: 0.5px solid #F4B95F;">
              <v-card-title class="justify-center" style="padding-bottom:0px;">
                <h3 style="color:#fd7e14;">{{ pck.ez }}</h3>
              </v-card-title>
              <v-card-title class="justify-center" style="padding-bottom:0px;padding-top:0px;">
                <h4 style="margin:0px;font-size:14px;">{{ pck.ll }}</h4>
              </v-card-title>
              <v-card-title style="padding-top:0px;" class="justify-center">
                <div>
                  <h4 style="font-size:18px;margin:0px;">RM</h4>
                  <h4 style="padding-left:20px;">
                    <span style="font-size:32px;">{{ pck.lp }}</span>
                  </h4>
                </div>
              </v-card-title>
            </v-card>
          </a>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="pckInfo">
      <div>
        <a @click="backToPckMain()">
          <v-icon style="font-size:30px;padding-left:2.5px;padding-top:2px;">arrow_back</v-icon>
        </a>
      </div>
      <v-card style="border-radius:10px;">
        <v-card-text>
          <h3 class="TrnHdr" style="overflow-wrap: break-word;font-size:24px;">{{sltPck.ez}}</h3>
          <h3 class="TrnHdr" style="font-size:14px;">{{sltPck.ll}}</h3>
          <h3 class="TrnHdr" style="font-size:16px;">{{$t('LimitItem')}} : {{sltPck.ru}}</h3>
          <h3 class="TrnHdr" style="font-size:16px;">{{$t('Month')}} : {{sltPck.rv}}</h3>
          <h3 class="TrnHdr" style="font-size:16px;">{{$t('Price')}} : RM {{sltPck.lp}}</h3>
          <div style="float:right;">
            <button
              class="btn btn-danger"
              style="min-width: 32px;"
              type="submit"
              @click="subQty()"
            >-</button>
            <button class="btn iPrice" style="min-width: 32px;" type="number">{{ buyQty }}</button>
            <button
              class="btn btn-success"
              style="min-width: 32px;"
              type="submit"
              @click="addQty()"
            >+</button>
          </div>
          <br />
          <br />
        </v-card-text>
      </v-card>
      <br />
      <v-btn style="float:right;" color="primary" @click="buyNow()">{{$t('BuyNow')}}</v-btn>
    </div>

    <v-layout class="text-xs-center">
      <v-dialog v-model="loadingDialog" persistent width="1000">
        <v-card height="200">
          <v-card-text>
            <br />
            <!-- <v-btn color="primary" style="float:right;" @click="closeLoadingDialog()">X</v-btn> -->
            <v-layout row wrap align-center>
              <v-progress-circular
                :size="100"
                :width="8"
                color="primary"
                indeterminate
                class="progress-circular"
              ></v-progress-circular>
            </v-layout>
            <div>
              <h3 class="loadingMsg">{{$t('InProgressPleaseWaitAMoment')}}</h3>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout class="text-xs-center">
      <v-dialog v-model="recordSaveDialog" persistent width="300">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            color="primary-title"
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text style="padding-top:5px;padding-bottom:0px;">
            <h2 style="margin:0px;">{{$t('RecordSuccessfullySaved')}}</h2>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" flat @click="recordSaveDialog = false">{{$t('Ok')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-container>
</template>

<script>
import JS from './JsonService'
import { translateErrorMsg } from './translateErrorMsg'
import VersionDialog from '../src/VersionNotMatchDialog'
export default {
  components: {
    VersionDialog
  },
  mixins: [translateErrorMsg],
  data() {
    return {
      packageName: '',
      limitItemQty: 0,
      expireTime: 0,
      packageList: [],
      accError: '',
      loadingDialog: false,
      recordSaveDialog: false,
      versionError: false,
      pckInfo: false,
      sltPck: [],
      buyQty: 1,
      timer: null
    }
  },
  created: function() {
    this.getMchPkg()
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    getMchPkg() {
      this.sltPck = []
      this.loadingDialog = true
      this.versionError = false
      let mchCode = sessionStorage.getItem('backendMchCode')
      var version = sessionStorage.getItem('version')
      const url = 'Back/GetMchPkg'
      const parameter = {
        av: version,
        kp: mchCode
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else if (response.data.ListOfMchPkg) {
            this.versionError = false
            this.loadingDialog = false
            this.accError = ''
            this.packageList = response.data.ListOfMchPkg

            if (response.data.ListOfMchPym) {
              this.packageName = response.data.ListOfMchPym[0].ez
              this.limitItemQty = response.data.ListOfMchPym[0].ru
              var expTime = new Date(
                response.data.ListOfMchPym[0].fc
              ).toLocaleDateString('zh-HK', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
              })
              this.expireTime = expTime
            } else {
              this.packageName = 'Trial Version'
              this.limitItemQty = 3
              this.expireTime = 0
            }
          } else {
            this.versionError = false
            this.loadingDialog = false
            this.accError = response.data
          }
        })
        .catch(error => {
          console.log(error)
          this.accError = error
          this.versionError = false
          this.loadingDialog = false
        })
    },
    clkPck(pck) {
      this.sltPck = pck
      this.buyQty = 1
      this.pckInfo = true
    },
    backToPckMain() {
      this.sltPck = []
      this.pckInfo = false
      window.scrollTo(0, 0)
    },
    subQty() {
      if (this.buyQty > 1) {
        this.buyQty = this.buyQty - 1
      }
    },
    addQty() {
      this.buyQty = this.buyQty + 1
    },
    buyNow() {
      console.log(this.sltPck)
      // var paymentURL = 'http://payment.postchat.us/' + this.sltPck.ez
      // // var paymentURL = 'http://192.168.8.109:8080/' + this.sltPck.ez
      // console.log()
      // this.paymentWeb = window.open(paymentURL)

      // window.addEventListener('message', this.receivedMsg)

      // this.timer = setInterval(this.checkIsWindowOpen, 1500)
    },
    receivedMsg(event) {
      console.log('event.data: ', event.data)
      if (event.data === this.sltPck.ez + ' opened') {
        clearInterval(this.timer)
        var paymentURL = 'http://payment.postchat.us/' + this.sltPck.ez
        this.paymentWeb.postMessage(this.sltPck.ez + ' detected', paymentURL)
        console.log('open')
      } else if (event.data === this.sltPck.ez + ' canceled') {
        // Canceled payment
        this.checkCanceled = true
        this.checkIsPaid()
      } else if (
        event.data === this.sltPck.ez + ' completed' ||
        event.data === this.sltPck.ez + ' closed'
      ) {
        this.checkIsPaid()
      }
    },
    checkIsWindowOpen() {
      var paymentURL = 'http://payment.postchat.us/' + this.sltPck.ez
      //console.log('checkIsWindowOpen')
      this.paymentWeb.postMessage(this.sltPck, paymentURL)
    },
    checkIsPaid() {
      console.log('check Paid')
    },
    incompletePayment() {
      this.userProfileDialog = false
      this.paymentStatusDialog = true
      this.paymentStatus = 'Incomplete payment... '
      this.paymentStatus2 = 'Press retry button to re-pay the payment.'
      this.paymentStatusCloseOnly = false
    }
  }
}
</script>

<style>
.statusTitle {
  font-size: 20px;
}
#pckTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
#pckTable tr th,
#pckTable tr td {
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  padding: 10px;
  text-align: left;
}
#pckTable tr th:first-child,
#pckTable tr td:first-child {
  border-left: 1px solid black;
}
/* top-left border-radius */
#pckTable tr:first-child th:first-child {
  border-top: 1px solid black;
  border-top-left-radius: 10px;
}

/* top-right border-radius */
#pckTable tr:first-child td:last-child {
  border-top: 1px solid black;
  border-top-right-radius: 10px;
}

/* bottom-left border-radius */
#pckTable tr:last-child th:first-child {
  border-bottom-left-radius: 10px;
}

/* bottom-right border-radius */
#pckTable tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}
</style>
